import { Route as RootRoute } from "@/routes/__root";
import type { Translations } from "./en";
import { getTranslator, translations } from "./index";
import { DEFAULT_LOCALE, localeToPathSegment } from "./locale";

export const useI18n = () => {
	const { locale, isLocalePrefixed } = RootRoute.useRouteContext();
	const translator = getTranslator(locale);
	const shouldPrefix = isLocalePrefixed || locale !== DEFAULT_LOCALE;
	const localeParam = shouldPrefix ? localeToPathSegment(locale) : undefined;

	return {
		locale,
		isLocalePrefixed,
		localeParam,
		t: translator,
		/** Whole dictionary, for sections that iterate over grouped copy. */
		dict: translations[locale] as Translations,
	};
};
